// @ts-nocheck
// 🔥 LAZY-LOAD DejaVuSans fonts (only when PDF is generated).
// Sync <script> in <head> used to block app boot + login. Now fetched on demand with 3s timeout.
let _fontsPromise: Promise<boolean> | null = null;

export function loadPdfFonts(): Promise<boolean> {
  if (typeof window === 'undefined') return Promise.resolve(false);
  const w = window as any;
  if (w.DejaVuSansBase64 && w.DejaVuSansBoldBase64) return Promise.resolve(true);
  if (_fontsPromise) return _fontsPromise;

  const loadOne = (src: string) => new Promise<void>((resolve) => {
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    const timeout = setTimeout(() => { console.warn('⏱️ font timeout:', src); resolve(); }, 3000);
    s.onload = () => { clearTimeout(timeout); resolve(); };
    s.onerror = () => { clearTimeout(timeout); console.warn('❌ font load failed:', src); resolve(); };
    document.head.appendChild(s);
  });

  _fontsPromise = Promise.all([
    loadOne('/fonts/DejaVuSans-normal.js'),
    loadOne('/fonts/DejaVuSans-bold.js'),
  ]).then(() => !!(w.DejaVuSansBase64 && w.DejaVuSansBoldBase64));
  return _fontsPromise;
}
